import React from 'react';
import { LoadingOverlayStyles } from '../styles/LoadingOverlay.styles';

const AccessDenied = () => {
    return (
        <div style={LoadingOverlayStyles.Overlay}>
            <div style={{ marginTop: '250px', color: 'red', textAlign: 'center', fontSize: 20 }}>
                شما به نقشه دسترسی ندارید
            </div>
        </div>
    );
};

export default AccessDenied;
